"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isVerticalTouchmoveDetected = exports.getFadeoutAnimationPosition = exports.getFadeoutAnimationIndex = exports.getSwipeTouchendIndex = exports.getSwipeTouchendPosition = exports.getSwipeTransformationCursor = exports.getTransformationItemIndex = exports.getSwipeShiftValue = exports.getTransformationSetItem = exports.getIsLeftDirection = exports.shouldRecalculateSwipePosition = exports.getSwipeLimitMax = exports.getSwipeLimitMin = exports.shouldCancelSlideAnimation = exports.shouldRecalculateSlideIndex = exports.getUpdateSlidePositionIndex = exports.getActiveIndex = exports.getStartIndex = exports.getShiftIndex = void 0, exports.getShiftIndex = function (t, e) {
  return void 0 === t && (t = 0), void 0 === e && (e = 0), t + e;
}, exports.getStartIndex = function (t, e) {
  return void 0 === t && (t = 0), void 0 === e && (e = 0), e && Math.min(t, e - 1) || 0;
}, exports.getActiveIndex = function (t, e, i) {
  return i ? t : Math.min(t, e);
}, exports.getUpdateSlidePositionIndex = function (t, e) {
  return t < 0 ? e - 1 : e <= t ? 0 : t;
}, exports.shouldRecalculateSlideIndex = function (t, e) {
  return t < 0 || e <= t;
}, exports.shouldCancelSlideAnimation = function (t, e, i) {
  return t < 0 || e - i < t;
}, exports.getSwipeLimitMin = function (t, e) {
  var i = t.itemsOffset,
      o = void 0 === i ? 0 : i,
      i = t.transformationSet,
      t = void 0 === i ? [] : i,
      i = e.infinite,
      e = e.swipeExtraPadding,
      e = void 0 === e ? 0 : e;
  if (i) return (t[o] || {}).position;
  t = (t[0] || {}).width, t = void 0 === t ? 0 : t;
  return Math.min(e, t);
}, exports.getSwipeLimitMax = function (t, e) {
  var i = e.infinite,
      o = e.swipeExtraPadding,
      n = void 0 === o ? 0 : o,
      r = t.itemsCount,
      e = void 0 === r ? 1 : r,
      o = t.itemsOffset,
      r = void 0 === o ? 0 : o,
      o = t.itemsInSlide,
      o = void 0 === o ? 1 : o,
      t = t.transformationSet,
      t = void 0 === t ? [] : t;
  return i ? (t[e + exports.getShiftIndex(o, r)] || {}).position || 0 : exports.getTransformationSetItem(-o, t).position + n;
}, exports.shouldRecalculateSwipePosition = function (t, e, i) {
  return -e <= t || Math.abs(t) >= i;
}, exports.getIsLeftDirection = function (t) {
  return void 0 === t && (t = 0), t < 0;
}, exports.getTransformationSetItem = function (t, e) {
  return void 0 === t && (t = 0), void 0 === e && (e = []), e.slice(t)[0] || {
    position: 0,
    width: 0
  };
}, exports.getSwipeShiftValue = function (t, e) {
  return void 0 === t && (t = 0), void 0 === e && (e = []), exports.getTransformationSetItem(t, e).position;
}, exports.getTransformationItemIndex = function (t, e) {
  return void 0 === t && (t = []), void 0 === e && (e = 0), t.findIndex(function (t) {
    return t.position >= Math.abs(e);
  });
}, exports.getSwipeTransformationCursor = function (t, e, i) {
  void 0 === t && (t = []), void 0 === e && (e = 0), void 0 === i && (i = 0);
  e = exports.getTransformationItemIndex(t, e);
  return exports.getIsLeftDirection(i) ? e : e - 1;
}, exports.getSwipeTouchendPosition = function (t, e, i) {
  void 0 === i && (i = 0);
  var o = t.infinite,
      n = t.autoWidth,
      r = t.isStageContentPartial,
      s = t.swipeAllowedPositionMax,
      t = t.transformationSet,
      e = exports.getSwipeTransformationCursor(t, i, e),
      t = exports.getTransformationSetItem(e, t).position;

  if (!o) {
    if (n && r) return 0;
    if (s < t) return -s;
  }

  return -t;
}, exports.getSwipeTouchendIndex = function (t, e) {
  var i = e.transformationSet,
      o = e.itemsInSlide,
      n = e.itemsOffset,
      r = e.itemsCount,
      e = e.infinite,
      t = exports.getTransformationItemIndex(i, t);

  if (e) {
    e = exports.getShiftIndex(o, n);
    return t < e ? r - o - n + t : e + r <= t ? t - (e + r) : t - e;
  }

  return t;
}, exports.getFadeoutAnimationIndex = function (t) {
  var e = t.infinite,
      i = t.activeIndex,
      t = t.itemsInSlide;
  return e ? i + t : i;
}, exports.getFadeoutAnimationPosition = function (t, e) {
  var i = e.activeIndex,
      e = e.stageWidth;
  return t < i ? (i - t) * -e || 0 : (t - i) * e || 0;
}, exports.isVerticalTouchmoveDetected = function (t, e, i) {
  return void 0 === i && (i = 0), t < i || t < .1 * e;
};